import { FormGroup, Input, Label } from 'reactstrap'

import { FeatureFlagListContainer } from '../components/FeatureFlagListContainer'

export type FFListItemType = string | number

interface FeatureFlagArrayItemProps {
  title: string
  value: FFListItemType[]
  lockedValues?: FFListItemType[]
  onChange: (values: FFListItemType[]) => void
  options: FFListItemType[]
  displayValues?: Record<string, string>
  disabled?: boolean
}

export const FeatureFlagArrayItem = ({
  title,
  value = [],
  lockedValues = [],
  disabled,
  options,
  displayValues,
  onChange,
}: FeatureFlagArrayItemProps) => {
  const handleChange = (actualValue: FFListItemType) => {
    const newValue = value.find((item) => item.toString() === actualValue.toString())
      ? value.filter((item) => item.toString() !== actualValue.toString())
      : [...value, actualValue]

    onChange(newValue)
  }

  const toggleAll = () => {
    if (value.length === options.length) {
      onChange(lockedValues)
    } else {
      onChange(options)
    }
  }

  const sortedOptions = options
    .map((optionKey) => ({
      key: optionKey,
      value: displayValues?.[optionKey] ?? optionKey.toString(),
    }))
    .sort((a, b) => (a.value > b.value ? 1 : -1))

  return (
    <FeatureFlagListContainer title={title} toggleAll={toggleAll}>
      {sortedOptions.map((option) => (
        <FormGroup key={option.key} check>
          <Label className="mb-0">
            <Input
              type="checkbox"
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
              disabled={disabled || lockedValues.includes(option.key)}
              checked={Boolean(value.find((item) => item.toString() === option.key.toString()))}
              onChange={() => handleChange(option.key)}
            />
            {option.value}
          </Label>
        </FormGroup>
      ))}
    </FeatureFlagListContainer>
  )
}
